<template>
  <div class="search_t">
	<div class="intro">SearchByTarget</div>
    <el-form ref="form" :inline="true" :model="form" label-width="80px">
      <el-form-item label="TargetID">
        <el-col :span="11">
          <el-input style="width:260px" :autosize="{ minRows: 2, maxRows: 10 }" v-model.trim="form.TargetID"></el-input>
        </el-col>
        <!-- <el-col>
          <el-upload
            class="upload-demo"
            action="/api/uploader"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-exceed="handleExceed"
            :on-success="onSuccess"
            :file-list="fileList"
            :multiple="false"
            :limit="1"
          >
            <el-button size="small">mol2/SDF Uplade</el-button>
          </el-upload>
        </el-col> -->
      </el-form-item>

      <el-form-item label="Name">
        <el-input style="width:260px" v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 20px;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >Search</el-button
        >
      </el-form-item>
    </el-form>

    <!--数据表格-->
    <el-table :data="showData" v-loading="loading" stripe border fit empty-text="No Data" style="width: 100%;font-size: 18px;">
      <el-table-column type="index" label="ID"> </el-table-column>
      <el-table-column prop="Target_ChEMBL_ID" label="TargetID" width="150px"> </el-table-column>
      <el-table-column prop="Name" label="Name" width="380px"> </el-table-column>
      <el-table-column prop="genus_species" label="Originism" width="380px"> </el-table-column>
      <el-table-column prop="Uniprot" label="Uniprot"></el-table-column>
      <el-table-column fixed="right" label="Detail">
        <template slot-scope="scope">
          <el-button @click="toDetail(scope.row.id)" type="text" size="small" style="font-size: 18px;">Detail</el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Inflam_Compound" width="160">
        <template slot-scope="scope">
          <el-button @click="toAbout(scope.row.id)" type="text" size="small" style="font-size: 18px;">Inflam_Compound</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-warp">
      <el-pagination @current-change="currentChange" background layout="prev, pager, next" :total="tableData.length"/>
    </div>
    <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>

  </div>
</template>

<script>
export default {
  name: "search_t",
  data() {
    return {
      form: {
        TargetID: "",
        name: "",
      },
      tableData: [],
      currentNum: 1,
      loading: false,
      fileList: [],
      iframeurl: "",
    };
  },
  computed: {
    showData() {
      let tableList = this.tableData.concat([]);
      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.currentNum = 1;
      this.tableData = [];
      this.$http({
        url: "/api/rdkit/queryByTarget",
        params: this.form,
        method: "get",
      }).then((res) => {
        this.tableData = res.data.data;
        if (!this.tableData.length) {
          this.$message.warning("No Target matched");
        }
        this.loading = false;
      });
    },
    currentChange(num) {
      this.currentNum = num;
    },
    
   
    onSuccess({ data }) {
      this.form.TargetID = data.join(",");
    },
    down() {
      const { TargetID, name } = this.form;
      this.iframeurl = `/api/exportCsv?TargetID=${TargetID}&name=${name}`;
    },
    toDetail(id) {
      const { origin, pathname } = window.location;
      window.location.href=`${origin}${pathname}#/main/searchBytar/detail_t?id=${id}`;
    //   window.open(`${origin}${pathname}#/main/searchBytar/detail_t?id=${id}`);
    },
    toAbout(id) {
      const { origin, pathname } = window.location;
      window.location.href=`${origin}${pathname}#/main/searchBytar/about_t?id=${id}`;
    //   window.open(`${origin}${pathname}#/main/searchBytar/about_t?id=${id}`);
    },
  },
  mounted() {
     this.onSubmit()
  }
};
</script>

<style scoped>
	.intro{margin:0 0 20px 0;border-bottom: 2px solid rgb(245,166,20);line-height:60px;text-align:center;font-size: 30px;color:#409EFF;}
	
  .page-warp {margin-top:10px;display:flex;justify-content:center;}
  .down-load {display:flex;justify-content:flex-end;}
  .demo-table-expand {font-size:0;}
  .demo-table-expand label {width:90px;color:#99a9bf;}
  .demo-table-expand .el-form-item {margin-right:0;margin-bottom:0;width:50%;}
  .search_t {padding:0 100px;margin:0 auto;}

</style>